// Magic-link login tokens must never reach Sentry (PROD-2197): replays record every page URL.
// takeLoginTokenFromUrl runs before Sentry.init, keeps the token in memory for the login view
// and removes it from the address bar.

let loginToken: string | null = null;

export const getLoginToken = () => loginToken;

export const clearLoginToken = () => {
  loginToken = null;
};

export function takeLoginTokenFromUrl() {
  const url = new URL(window.location.href);
  const next = url.searchParams.get('next');

  // infobip encoding puts all query params under 'next' (e.g. next=/app&token=…) - spread them out
  // so the token can be found and removed
  if (next?.includes('&')) {
    const [path, ...rest] = next.split('&');
    url.searchParams.set('next', path);
    new URLSearchParams(rest.join('&')).forEach((value, key) => url.searchParams.set(key, value));
  }

  loginToken = url.searchParams.get('token');
  if (!loginToken && !next?.includes('&')) return;
  url.searchParams.delete('token');
  window.history.replaceState(window.history.state, '', url);
}
